import {Base} from "../Base";
import {BodyText, CommonList, HeaderText, SubHeaderText} from "../util/FontUtil";
import {useEffect} from "react";

export const TermPage = () => {
  useEffect(() => {
    document.title = "ai広場 利用規約"
  }, [])

  return <Base>

    <HeaderText>利用規約</HeaderText>

    <SubHeaderText>1. はじめに</SubHeaderText>
    <BodyText>
      この利用規約はai広場が提供するサービスの利用に関する一切の行為に適用されます。
      利用者は、本規約に同意した上でai広場を利用するものとします。
    </BodyText>

    <SubHeaderText>2. 定義</SubHeaderText>
    <CommonList>
      <li>「ユーザー」はai広場を利用する者のことをさします。</li>
      <li>「ベイビー」はai広場で提供する人工無脳のことをさします。</li>
      <li>「管理者」はai広場の運営者のことをさします。</li>
    </CommonList>

    <SubHeaderText>3. 規約の改訂</SubHeaderText>
    <BodyText>
      本規約は管理者の判断により、いつでも変更できるものとします。
      変更を行った場合、適切な方法で周知します。
      規約の変更後に当サイトを利用したユーザーは、変更後の規約について同意したものとみなします。
    </BodyText>

    <SubHeaderText>4. 個人情報</SubHeaderText>
    <BodyText>
      後述する個人情報保護方針に基づいた運用を行います。
    </BodyText>

    <SubHeaderText>5. 禁止事項</SubHeaderText>
    <CommonList>
      <li>自身が保有していない著作権などの知的財産権を侵害する行為</li>
      <li>他者の名誉を毀損する行為</li>
      <li>犯罪を助長する行為</li>
      <li>無断で他者の個人情報を掲載する行為</li>
      <li>不当にai広場の運営を妨げる行為</li>
      <li>不当にベイビーの製作を妨げる行為</li>
      <li>実写のわいせつ画像をアップロードする行為</li>
      <li>運営者、もしくは第三者へなりすます行為</li>
      <li>有害なプログラムなどを掲載・送信する行為</li>
      <li>その他管理者が不適切であると判断した行為</li>
    </CommonList>

    <SubHeaderText>6. 違反行為への対応</SubHeaderText>
    <BodyText>
      ユーザーが規約に違反したと管理者が認める場合、事前の通知なくユーザーのアカウントの削除およびこれに準ずる措置を行うことがあります。
      ただし、この措置に至った理由もしくは措置に至らなかった理由を開示する義務は負いません。
      ユーザーは措置が行われた場合、管理者に対して意義を唱えないものとします。
    </BodyText>

    <SubHeaderText>7. 権利の帰属</SubHeaderText>
    <BodyText>
      ユーザーは自身が入力した文章の著作権について、送信をした時点において管理者が使用、改変することに同意したものとみなします。
      ユーザーは当管理者が許諾した第三者が文章を利用することに同意したものとみなします。
    </BodyText>

    <SubHeaderText>8. 免責事項</SubHeaderText>
    <BodyText>
      管理者は事前の予告なくサービスの提供を中断・停止する場合があります。
      これによりユーザーにおいて生じた損害は、直接的・間接的なものを問わず、管理者は責任を負いません。
      当サイトを利用するために発生した通信料について、管理者は責任を負いません。
      ユーザーが作成したベイビーおよびデータにおいて破損が発生した場合において、管理者は責任を負いません。
      当サイトを利用することにより損害が発生した場合、管理者は責任を負いません。
    </BodyText>
    <BodyText>
      管理者は裁判所・警察ならびに準ずる機関から法令に基づく照会を受けた場合、ユーザーの個人情報を第三者に開示・提供できるものとします。
      人の生命や財産などの保護の必要がある場合、第三者に開示・提供できるものとします。
    </BodyText>

    <HeaderText>著作権について</HeaderText>

    <SubHeaderText>各種の権利を有する方へ</SubHeaderText>
    <BodyText>
      権利違反の画像や文章等がベイビーに掲載されている場合、削除依頼が可能です。
      削除依頼はメールフォームから下記の書式でご連絡ください。
    </BodyText>

    <BodyText>
      <p>件名:削除依頼</p>
      <p>削除依頼者：○○○○(権利保持者名)</p>
      <p>削除対象：https://ai-saloon.com……(権利違反のURL)</p>
      <p>※URL中の何が違反しているか記載してください。</p>
      <p>※複数列記する場合はその都度改行してください。</p>
    </BodyText>

    <BodyText>
      この申請を行う場合、必ず権利を保持していると確認できるリモートホスト(IPアドレス)からご依頼ください。
      権利を保持していると確認できない場合、削除することが出来ません。．
    </BodyText>

    <HeaderText>個人情報保護方針</HeaderText>
    <SubHeaderText>1. 収集の方針</SubHeaderText>
    <BodyText>
      当サイトはユーザー登録を行う場合において、メールアドレスの収集を行います。
      IPアドレスや送信したあらゆる情報についても収集を行います。
    </BodyText>

    <SubHeaderText>2. 第三者への提供について</SubHeaderText>
    <BodyText>
      個人が特定できる情報について、原則として第三者へ個人情報の提供を行いません。
      ただし、法令に基づく場合、ユーザーの同意を得た場合、もしくはやむを得ない事情がある場合においては提供をする場合があります。
      個人が特定できない情報、もしくは個人が特定できないように加工された情報は第三者に提供する場合があります。
    </BodyText>

    <SubHeaderText>3. 免責事項</SubHeaderText>
    <BodyText>
      以下の場合において、管理者は責任を負いません。
    </BodyText>
    <CommonList>
      <li>
        ユーザー自身が個人情報を明らかにした場合
      </li>
    </CommonList>

  </Base>
}